export default "__VITE_ASSET__BqbwfZt3__"